import HttpRequest from '@/libs/axios'
import config from '@/config'

const baseUrl = process.env.NODE_ENV === 'development' 
  ? config.baseUrl.dev 
  : (config.baseUrl.pro || 'https://www.smartmtm.com/api')

// 调试信息 - 生产环境可以删除
console.log('Current environment:', process.env.NODE_ENV)
console.log('Base URL:', baseUrl)

const axios = new HttpRequest(baseUrl)
export default axios


// WEBPACK FOOTER //
// ./src/libs/api.request.js